import React, { useState } from "react";
import TestsID from "../../../utils/TestsID";
import { tt } from "../../../utils/i18n/i18n";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SaasFlyersOrderActionWrapper from "./SaasFlyersOrderActionWrapper";
import TSUtils from "../../../utils/helpers/TSUtils";
import { SaasFlyersOrderQuantityRow } from "./SaasFlyersOrderQuantityRow";
import KC_Table from "../../../designsystem/KC_Table/KC_Table";
import KC_Span from "../../../designsystem/KC_Span/KC_Span";
import KC_Colors from "../../../designsystem/KC_Colors";
import { type RootStateI } from "../../../redux";
import {
  type POSAOrderItem,
  setFlyersOrderStep
} from "../../../redux/saas/reducer";
import { updatePOSAOrderThunk } from "../../../redux/saas/thunks";
import {
  usePOSAPricesSelector,
  usePOSATypesSelector
} from "../../../redux/actions/wheel";
import { FLYERS_ORDER_STEP_DELIVERY } from "../../../utils/constants";
import {
  Currencies,
  DEFAULT_CURRENCY_SUB_UNITS
} from "@tootsweet/model/enums/Currencies";
import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";
import { POSAPricesJavascriptDTO } from "@tootsweet/model/lottery/POSAPrices";

// TODO EGH: delete this
export default function SaasFlyersOrderQuantitySelection() {
  const history = useHistory();
  const dispatch = useDispatch();

  const posaTypes = usePOSATypesSelector();
  const posaPrices = usePOSAPricesSelector();

  const { items } = useSelector(
    (state: RootStateI) => state.saas.currentPOSAOrder
  );
  const currentPOSAOrder = useSelector(
    (state: RootStateI) => state.saas.currentPOSAOrder
  );

  const [totalPrices, setTotalPrices] = useState<POSAOrderItem[]>([]);

  function handleTotal(key: string | undefined, value: POSAOrderItem) {
    if (!key || value === undefined) return;
    const totalFound = totalPrices?.find((item) => item.posaTypeId === key);
    if (totalFound == null) {
      setTotalPrices((previousTotal) => [...previousTotal, value]);
    } else {
      // Here we replace the item if found in the list of totals
      const filteredTotalPrices = totalPrices?.filter(
        (total: POSAOrderItem) => total?.posaTypeId !== key
      );
      setTotalPrices([...filteredTotalPrices, value]);
    }
  }

  function handlePrev() {
    history.goBack();
  }

  function getPOSAPricesByType(
    type: POSATypeJavascriptDTO,
    posaPrices: POSAPricesJavascriptDTO[]
  ) {
    const prices = posaPrices.find(
      (price) => price && price._id === type.helloPrintSlug
    );
    return prices ?? null;
  }

  async function handleNext() {
    dispatch(
      updatePOSAOrderThunk({
        ...currentPOSAOrder,
        items: totalPrices
      })
    );
    dispatch(setFlyersOrderStep(FLYERS_ORDER_STEP_DELIVERY));
  }

  return (
    <div id={TestsID.SAAS_FLYERS_ORDER_PAGE_QUANTITY_CONTAINER}>
      <KC_Table
        id={TestsID.GIFT_EDITOR_TABLE}
        keyPrefix="flyers-order"
        headers={
          <>
            <th>{tt("saas_flyers_order_quantity_thead_type")}</th>
            <th className="saas-flyer-order__large-column">
              {tt("saas_flyers_order_quantity_thead_description")}
            </th>
            <th>{tt("saas_flyers_order_quantity_thead_quantity")}</th>
            <th>{tt("saas_flyers_order_quantity_thead_unit_price_ht")}</th>
            <th>{tt("saas_flyers_order_quantity_thead_total_price_ht")}</th>
          </>
        }
        children={posaTypes?.map((type) => (
          <SaasFlyersOrderQuantityRow
            key={type._id}
            initialValue={items?.find((item) => item?.posaTypeId === type?._id)}
            posaType={type}
            posaPrices={getPOSAPricesByType(type, posaPrices)}
            handleTotal={handleTotal}
          />
        ))}
      />
      <div className="saas-flyers-order__total-price-container">
        <KC_Span
          text={tt("saas_flyers_order_quantity_thead_total_price_ht")}
          color={KC_Colors.Grey}
        />
        <KC_Span
          text={TSUtils.formatAmount(
            currentPOSAOrder.totalPriceTTC,
            DEFAULT_CURRENCY_SUB_UNITS,
            false,
            Currencies.CURRENCY_EUR
          )}
          color={KC_Colors.Red}
          isBold={true}
        />
      </div>
      <SaasFlyersOrderActionWrapper
        actionsLabel={[
          tt("saas_flyers_order_quantity_action_prev"),
          `${tt("saas_flyers_order_quantity_action_next")} >`
        ]}
        nextDisabled={!computeFinalPrice(totalPrices)}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
    </div>
  );
}

function computeFinalPrice(totalPrices: POSAOrderItem[]): number {
  if (!totalPrices?.length) {
    return 0;
  }
  const total: number = totalPrices?.reduce((accumulator, current) => {
    return accumulator + (current?.priceTTC || 0);
  }, 0);
  return total;
}
